// External app'lere SSO ile gecis. Sidebar'da "Diger Uygulamalar"
// bolumunde bir kart tiklandiginda cagrilir. Akis:
//   1. Popup blocker'i by-pass etmek icin YENI SEKME onClick anında acilir
//      (about:blank ile). Backend cagrisi bittiginde URL set edilir.
//   2. Backend /sso/issue-token endpoint'ine POST (JWT auth). Response:
//      { token: "abc123..." } — 60sn omurlu, tek kullanimlik.
//   3. Yeni sekme app.baseUrl + app.ssoCallbackPath + ?token=<token> URL'ine
//      yonlendirilir. Dis uygulama token'i CRM backend'e verify ettirir ve
//      kendi session'ini acar.
//
// Backend endpoint henuz yoksa (yolda), simdilik "coming soon" mesaji
// dondurup sekmeyi kapatir.

import authService from '../services/authService';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

/**
 * @param {{ code: string, name: string, baseUrl: string, ssoCallbackPath: string }} app
 * @param {(msg: string, severity?: string) => void} [notify] Opsiyonel:
 *   useNotification'dan gelen showNotification fonksiyonu (hata durumunda
 *   toast gostermek icin).
 */
export async function openExternalApp(app, notify = null) {
  if (!app?.baseUrl) return;

  // 1) Popup blocker bypass — kullanicinin onClick jestinden hemen once
  //    yeni sekme ac. Bos sayfa acilir, token gelince URL set edilir.
  //    NOT: `noopener,noreferrer` bazi Chrome versiyonlarinda popup olarak
  //    flag edildigi icin bilincli olarak eklenmiyor. Yeni sekme dis
  //    domain'e yonlendirildiginde tarayici zaten opener referansini
  //    cross-origin blocker'a takar.
  const newTab = window.open('about:blank', '_blank');
  if (!newTab) {
    // Popup engellenmis. Kullaniciya bilgi ver.
    notify?.('Yeni sekme açılamadı. Tarayıcı adres çubuğundaki popup ikonundan bu siteye izin verin.', 'error');
    return;
  }

  try {
    const accessToken = authService.getAccessToken();
    if (!accessToken) {
      newTab.close();
      notify?.('Oturumunuz sonlanmış görünüyor, tekrar giriş yapın.', 'error');
      return;
    }

    const res = await fetch(`${API_BASE}/sso/issue-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'x-api-key': process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({ target_app: app.code }),
    });

    if (!res.ok) {
      newTab.close();
      // Backend henuz hazir degilse 404 gelir — kullaniciya net bilgi.
      const msg = res.status === 404
        ? `${app.name} entegrasyonu henüz hazır değil.`
        : `${app.name} açılamadı (HTTP ${res.status}).`;
      notify?.(msg, 'warning');
      return;
    }

    const data = await res.json();
    if (!data?.token) {
      newTab.close();
      notify?.(`${app.name} için giriş token'ı alınamadı.`, 'error');
      return;
    }

    const url = `${app.baseUrl}${app.ssoCallbackPath || '/sso/callback'}?token=${encodeURIComponent(data.token)}`;
    newTab.location.href = url;
  } catch (err) {
    newTab.close();
    notify?.(`${app.name} açılırken hata: ${err?.message || err}`, 'error');
  }
}
